module.exports = __webpack_public_path__ + "static/img/down-arrow.b447df0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/down-arrow.png
// module id = 4qjm
// module chunks = 1